import { render, staticRenderFns } from "./tabCom.vue?vue&type=template&id=345e64a7&scoped=true"
import script from "./tabCom.vue?vue&type=script&lang=js"
export * from "./tabCom.vue?vue&type=script&lang=js"
import style0 from "./tabCom.vue?vue&type=style&index=0&id=345e64a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345e64a7",
  null
  
)

export default component.exports